// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3078315","732":"1607ab41","952":"43024509","977":"901cf9f7"}[chunkId] + ".chunk.js";
};